import { NotificationRecipients } from '../models/recipients';

export function sameRecipients(a: NotificationRecipients, b: NotificationRecipients): boolean {
  return sameIds(a.users, b.users) && sameIds(a.roles, b.roles);
}

function sameIds(a: string[], b: string[]): boolean {
  const other: Set<string> = new Set(b);
  return a.length === b.length && a.every(id => other.has(id));
}
